import IacstLogo from "../assets/IACST_Logo.png";
import AakashLogo from "../assets/AakashLogo.png";
import callDialer from "../assets/call.png";
import ScolarshipLogo from "../assets/ScolarshipLogo";
import SubjectWiseAnalysisLogo from "../assets/SubjectWiseAnalysisLogo";
import AcademicLogo from "../assets/AcademicLogo";

export default function IacstPage({ Response, isQualified }) {
  const qr = Response.centerData.center_detail.qr_code;
  const eligibleForScholarship = Response.scholarship.remarks;  

  const studentDetails = [
    [
      "Roll No. / PSID",
      `${Response.profile.roll_number} / ${Response?.profile?.psId || "NA"}`,
    ],
    ["Name of the Candidate", Response.profile.name],
    ["Father's Name", Response.profile.father_name],
    [
      "Stream / Class Opted",
      `${
        Response.profile.stream === "SOF"
          ? "Foundation"
          : Response.profile.stream === "SOM"
          ? "Medical"
          : "Engineering"
      } / ${Response.profile.class_opted}`,
    ],
    ["Percentage Marks", Response.percentage + "%"],
    [
      "iACST Result",
      isQualified
        ? `Qualified* | ${eligibleForScholarship}`
        : "Not Eligible. * However, eligible for other admission cum scholarship opportunities",
    ],
  ];

  const renderStudentDetail = (item, index) => (
    <div
      className="col d-flex align-items-center flex-row py-2"
      style={{
        maxWidth: "100%",
        backgroundColor: index % 2 === 0 ? "#FFFFFF" : "",
      }}
      key={index}
    >
      <span className="text-start ms-5 w-50" style={{color:'#5B5B5B'}}>{item[0]}</span>
      <div className="mx-2">:</div>
      <span className={`ms-5 text-start w-50 ${index == 0 ? "fw-bold" : ""}`}style={{color:'#5B5B5B'}}>
        {item[1]}
      </span>
    </div>
  );

  const renderContactNumber = (number, index, numbers) => (
    <div key={index} className="col my-2">
      {index % 2 === 0 && index + 1 < numbers.length ? `${number}, ` : number}
    </div>
  );

  const renderCircleCard = (Logo, text, bgColor, content, subtext) => (
    <div className="d-flex flex-column align-items-center">
      <div
        className="position-relative rounded-circle d-flex flex-column justify-content-center align-items-center"
        style={{
          backgroundColor: bgColor,
          width: "250px",
          height: "250px",
        }}
      >
        <div
          className="position-absolute rounded-circle fs-2 text-center"
          style={{
            width: "50px",
            height: "50px",
            left: 0,
            top: 30,
            border: "1px solid #FFFFFF",
            backgroundColor: "#F6F6F6",
            color: "#926CAC",
          }}
        >
          {content}
        </div>
        <Logo
          style={{
            width: text === "ACADEMIC COUNSELLING" ? "75px" : "50px",
            height: text === "ACADEMIC COUNSELLING" ? "75px" : "50px",
            marginBottom: "10px",
          }}
        />  
        <p className="text-center mb-0" style={{ fontSize: "24px",maxWidth: '155px', textAlign: 'center', color: '#1A1A1A' }}>
          {text}
        </p>
        {subtext && (
          <p className="text-center mt-0" style={{ fontSize: "10px" }}>
            {subtext}
          </p>
        )}
      </div>
    </div>
  );

  return (
    <div className="p-4 d-flex flex-column gap-4" style={{ height: "100%", backgroundImage: '/src/assets/iACST_Background.png', borderImageRepeat: 'repeat' }}>
      <div
        className="d-flex justify-content-between"
        style={{ paddingBottom: "20px" }}
      >
        <img
          src={IacstLogo}
          className="img-fluid"
          style={{ width: "400px", height: "200px" }}
          alt="iacst-logo"
        />
        <img
          src={AakashLogo}
          className="img-fluid align-self-center"
          style={{ width: "200px", height: "100px" }}
          alt="aakash-logo"
        />
      </div>
      <div
        className="text-center py-4 px-3 mb-4"
        style={{ backgroundColor: "#EBEDEC", borderRadius: "10px" }}
      >
        {isQualified ? (
          <>
            <h1 style={{ color: "#85438B", fontWeight: "bold" }}>
              Congratulations!
            </h1>
            <h2 style={{ fontWeight: "bold",color: '#3A3A3A' }}>
              You have qualified for {Response?.scholarship?.tuitionFee || 0}%
              scholarship* based on your iACST Score.
            </h2>
          </>
        ) : (
          <p className="text-start">{eligibleForScholarship}</p>
        )}

        <div
          className="d-flex justify-content-center text-white p-2"
          style={{ backgroundColor: "#029FE1", borderRadius: "10px", border: '1px solid #000000', boxShadow: '0px 4px 4px 0px #00000040' }}
        >
          <h3 className="mt-1">
            iACST Scholarship is valid for
            <span style={{ color: "#FFE500" }}> One Month </span>
            from the date of exam.
          </h3>
        </div>

        <div
          className="d-flex text-start justify-content-between py-2 mt-2 px-4"
          style={{ backgroundColor: "#D0E5EB", borderRadius: "10px" }}
        >
          <div className="d-flex flex-column" style={{ minHeight: "250px" }}>
            <span className="text-start fw-bold fs-4">Branch Address:</span>
            <span className="text-start">
              {Response.centerData.center_detail.address}
            </span>
            <div className="my-4" style={{ border: "1px solid #000000" }} />
            <span className="text-start fw-bold fs-4">
              Branch Contact Details:
            </span>
            <div
              className="row row-cols-2"
              style={{ fontWeight: "bold", maxWidth: "350px" }}
            >
              {Response.centerData.center_detail.contact_numbers.map(
                (number, index) =>
                  renderContactNumber(
                    number,
                    index,
                    Response.centerData.center_detail.contact_numbers
                  )
              )}
            </div>
          </div>
          <div
            className="d-flex flex-column bg-white"
            style={{ borderRadius: "10px", maxWidth: "200px" }}
          >
            <img
              className="img-fluid w-75 h-75 mx-auto"
              src={qr}
              alt="qr-code"
            />
            <span className="text-center p-2 fw-bold">
              Scan the QR code and get the branch location in your Google Maps
            </span>
          </div>
        </div>
      </div>

      <div
        className="d-flex justify-content-center flex-column"
        style={{ backgroundColor: "#E6E6E6", borderRadius: "10px" }}
      >
        <div
          className="d-flex align-items-center"
          style={{ backgroundColor: "#0F4C8C", borderRadius: "10px 10px 0 0" }}
        >
          <p className="text-center fs-2 fw-bold text-white w-100 m-0">
            RESULT
          </p>
        </div>
        <p
          className="text-center fs-2 fw-bold w-100 m-0"
          style={{ backgroundColor: "#E6E6E6",color: '#434242', border: "2px dotted #C5C6C6" }}
        >
          FOR CLASS {Response.profile.class_studying} STUDYING STUDENT
        </p>
        <div
          style={{
            border: "2px dotted #C5C6C6",
            borderTop: 0,
            borderRadius: "0 10px 0",
          }}
        >
          {studentDetails.map((item, index) =>
            renderStudentDetail(item, index)
          )}
        </div>
      </div>

      <p className="text-start mt-n10" style={{color: '#4D4D4D'}}>
        *The secured scholarship is applicable on Classroom Courses
      </p>

      <div className="d-flex flex-column" style={{ paddingBottom: "40px" }}>
        <div
          className="py-2 text-center fs-2 fw-bold"
          style={{
            backgroundColor: "#784C90",
            color: "#FFFFFF",
            borderRadius: "10px 10px 0 0",
          }}
        >
          PLEASE VISIT YOUR NEAREST BRANCH OR CALL FOR
        </div>
        <div
          className="d-flex justify-content-around pt-4 pb-4"
          style={{
            background: "#F3F3F3",
            border: "2px dotted #C5C6C6",
            borderTop: "none",
          }}
        >
          {renderCircleCard(
            ScolarshipLogo,
            "SCHOLARSHIP DETAILS",
            "#FCF3DA",
            "1",
            isQualified ? null : "(for Direct Admissions)"
          )}
          {renderCircleCard(
            SubjectWiseAnalysisLogo,
            "SUBJECT WISE ANALYSIS",
            "#D0E5EB",
            "2"
          )}
          {renderCircleCard(
            AcademicLogo,
            "ACADEMIC COUNSELLING",
            "#FCF3DA",
            "3"
          )}
        </div>
      </div>
      <div className="d-flex justify-content-end" style={{ marginTop: "auto" }}>
        <div className="border-top d-flex gap-4 p-2 mt-5 justify-content-end">
          <div className="d-flex flex-column mt-1">
            <div className="d-flex align-items-start">
              <span className="fw-bold me-1">Corporate Office:</span>
              <span style={{textAlign:'end'}}>3rd Floor, Incuspaze Campus – 2, Plot No. 13, Sector – 18,<br/>
                    Udyog Vihar, Gurugram, Haryana - 122015</span>
            </div>
            <div className="text-end">
              <span className="fw-bold">Ph.:</span> (011) 47623456
              <span className="fw-bold">| E-mail:</span> care@aesl.in
            </div>
          </div>
          <div
            style={{
              width: "1px",
              height: "50px",
              marginTop: "5px",
              backgroundColor: "#000000",
            }}
          />
          <div className="d-flex align-items-center gap-3">
            <img
              src={callDialer}
              className="img-fluid"
              style={{ width: "50px", height: "50px" }}
              alt="call-dialer"
            />
            <div className="d-flex flex-column align-items-start">
              <p className="fw-bold mb-0">TOLL FREE NUMBER</p>
              <p className="fs-3 fw-bold mb-0">1800-102-2727</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
